import axios from './axios';

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

export default class BaseAuthApi {
    auth
    locationId

    constructor(auth, locationId) {
        this.auth = auth;
        this.locationId = locationId;
    }

    api = () => `${API_BASE_URL}/inv/v1`;
    authHeaders = () => ({ Authorization: this.auth });
    url = (path) => `${this.api()}/${this.locationId}/${path}`;

    get(path, params) {
        if (!path) throw new Error('Path is required for GET requests');

        return axios.get(this.url(path), {
            headers: this.authHeaders(),
            params,
        });
    }

    post(path, body) {
        if (!path) throw new Error('Path is required for POST requests');

        return axios.post(this.url(path), body, {
            headers: this.authHeaders(),
        });
    }
}
